import { render, staticRenderFns } from "./InstallCode.vue?vue&type=template&id=4ca2b616&scoped=true"
import script from "./InstallCode.vue?vue&type=script&lang=js"
export * from "./InstallCode.vue?vue&type=script&lang=js"
import style0 from "./InstallCode.vue?vue&type=style&index=0&id=4ca2b616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2b616",
  null
  
)

export default component.exports